import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'

const EventBusContext = createContext()
const useEventBusContext = () => useContext(EventBusContext)

class EnvetBusHandler {
    handlers = {}

    // eslint-disable-next-line
    on = (key, handler) => {
        if (this.handlers[key] === undefined) {
            this.handlers[key] = []
        }
        this.handlers[key].push(handler)

        return () => {
            this.off(key, handler)
        }
    }

    // eslint-disable-next-line
    off = (key, handler) => {
        const index = this.handlers[key]?.indexOf(handler) ?? -1
        this.handlers[key]?.splice(index >>> 0, 1)
    }

    // eslint-disable-next-line
    fire = (key, payload) => {
        this.handlers[key]?.forEach((callback) => {
            try {
                callback(payload)
            } catch (e) {
                //skip error
            }
        })
    }

}

const EventBusProvider = ({ children }) => {
    const eventbus = new EnvetBusHandler()

    return <EventBusContext.Provider value={eventbus}>{children}</EventBusContext.Provider>
}

EventBusProvider.propTypes = {
    children: PropTypes.node
}

export { useEventBusContext, EventBusProvider }

